<div (click)="preventGridSelection()" class="d-flex align-items-center h-100">
  <svg-icon *ngIf="value" class="d-flex" src="asset/image/icon/point.svg"></svg-icon>
  <svg-icon *ngIf="!value" class="d-flex" src="asset/image/icon/point.svg"></svg-icon>
</div>
